export const EVENTS_ROOT = '/events';

export const ROUTES = {
  attendeeInsights: `${EVENTS_ROOT}/transactions`,
  integrations: `${EVENTS_ROOT}/integrations`,
  designWidget: `${EVENTS_ROOT}/design-widget`,
  design: `${EVENTS_ROOT}/design`,
  siteSettings: `${EVENTS_ROOT}/settings`,
  promotional: `${EVENTS_ROOT}/engage-promote`,
  analytics: `${EVENTS_ROOT}/analytics`,
  payouts: `${EVENTS_ROOT}/payouts`,
  seatingCharts: `${EVENTS_ROOT}/seating-charts`,
  team: `/sites/:site-id/team`,
  adminDashboard: `/admin/dashboard`,
  organization: `/sites/:site-id/organization/settings`,
  organizationTeam: `/sites/:site-id/organization/team`,
};
